// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__OBKsF","imageUploader":"EGiftCard_imageUploader__3JxpA"};